/// <reference path="../include.ts" />

namespace gpx_visualizer_phase2 {

	import QueryString = alm.browser.QueryString;

	export class Config {

		// --------------------------------------------------
		// Mode
		public static mode:Mode = Mode.Interactive;

		// --------------------------------------------------
		// Environment
		public static environment:Environment = Environment.Web;

		// --------------------------------------------------
		// Control settings
		public static readonly useProgressByDistance:boolean = true;

		public static readonly progressDurations:number[] = [60, 30];
		public static progressDurationDefaultIndex:number = 0;

		// --------------------------------------------------
		// Visual settings
		public static terrainElevationMaxScale:number = 1.5;
		public static readonly terrainElevationOffset:number = 0;

		public static usePhotoTexture:boolean = true;
		//public static photoTextureDeltaZoomLevel:number = 0;
		public static readonly photoTextureTargetResolution:number = 1536;
		public static readonly photoTextureMaxZoomLevel:number = 18;

		// --------------------------------------------------
		// Network settings
		public static useDevServer:boolean;
		public static readonly useProxy:boolean = false;

		// --------------------------------------------------
		// Error messages
		public static readonly sentryMessageNoWebGl:string = 'WebGL context is not supported';

		public static readonly errorNoWebGl:string = '申し訳ございません<br>お使いの端末は3Dリプレイに未対応です';
		public static readonly errorTimeout:string = '申し訳ございません<br>該当の活動日記では、現在3Dリプレイをご利用いただけません<br>しばらく時間をおいてお試しください';
		public static readonly errorNotAuthorized:string = '申し訳ございません<br>該当の活動日記にはアクセスできません';
		public static readonly errorNotFound:string = '申し訳ございません<br>該当の活動日記が見つかりません';
		public static readonly errorClientError:string = '申し訳ございません<br>エラーが発生しました。繰り返し発生する場合はお問い合わせください';
		public static readonly errorServerError:string = '申し訳ございません<br>エラーが発生しました。しばらく時間をおいてお試しください';
		public static readonly errorGeneral:string = '申し訳ございません<br>該当の活動日記では、現在3Dリプレイをご利用いただけません';
		public static readonly errorTerrainPhotoTexture:string = '申し訳ございません<br>該当の活動日記では、航空写真モードはご利用いただけません';





		public static initialize():void {
			const query = new QueryString(window.location.href);

			// recording = 0 or 1
			this.mode = query.getBool('recording', false) ? Mode.Recording : Mode.Interactive;
			trace('[Config] mode :', this.mode);

			// environment
			this.environment = window.navigator.userAgent.toLocaleLowerCase().indexOf('yamap') == -1 ? Environment.Web : Environment.App;
			trace('[Config] environment :', this.environment);

			// API server
			this.useDevServer = query.getBool('dev', window.location.hostname === '3dmap-dev.yamap.com');
			trace('[Config] use dev server :', this.useDevServer);

			// photo texture
			this.usePhotoTexture = query.getBool('photo', this.usePhotoTexture);
			trace('[Config] photo texture enabled :', this.usePhotoTexture);

			//this.photoTextureDeltaZoomLevel = Math.max(query.getInt('photo_zoom_delta', this.photoTextureDeltaZoomLevel), 0);
			//trace('[Config] photo texture delta zoom level :', this.photoTextureDeltaZoomLevel);

			// height scale
			this.terrainElevationMaxScale = query.getFloat('height_scale', this.terrainElevationMaxScale);
			trace('[Config] height scale :', this.terrainElevationMaxScale);

			// speed = 1 or 2
			//this.progressDurationDefaultIndex = query.getInt('speed', this.mode == Mode.Recording ? 2 : 1) - 1;
			this.progressDurationDefaultIndex = this.mode == Mode.Recording ? 1 : 0; // speedパラメータの引き継ぎを無効化
		}

		private constructor() {
		}
	}
}
